export default __webpack_public_path__ + "static/media/README.ab34b526.md";